import { render } from "./MediaflowMenu.vue?vue&type=template&id=44478334"
import script from "./MediaflowMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44478334"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44478334', __exports__)) {
    api.reload('44478334', __exports__)
  }
  
  module.hot.accept("./MediaflowMenu.vue?vue&type=template&id=44478334", () => {
    api.rerender('44478334', render)
  })

}


export default __exports__